import React, { HTMLAttributes, PropsWithChildren } from 'react'

import { cn } from '@app/utils'

export default function Page({ className, ...props }: PropsWithChildren<HTMLAttributes<HTMLDivElement>>) {
  return <div className={cn("px-md lg:px-lg pb-md h-full", className)} {...props} />
}
